const GO_EDU_FALLBACK_URL = "https://bookrclass.go.vn/sso/loginGoEdu/?partner_redirect_uri=https://web-bookrclass.go.vn";

export function getGoEduSsoUrl({ isStaging, prodUrl, stagingUrl }) {
  const preferredUrl = isStaging ? stagingUrl : prodUrl;
  if (preferredUrl !== undefined && preferredUrl !== null && preferredUrl !== "") {
    return preferredUrl;
  }

  return GO_EDU_FALLBACK_URL;
}
